/**
 * The key used by Okta's internal TokenManager when storing the id token in localStorage.
 */
export const OKTA_ID_TOKEN_KEY = 'TOGGLE_ID_TOKEN_KEY';

/**
 * The key used by Okta's internal TokenManager when storing the access token in localStorage.
 */
export const OKTA_ACCESS_TOKEN_KEY = 'TOGGLE_ACCESS_TOKEN_KEY';
